!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, i = {}, o = t.parcelRequire5f74;
  null == o && ((o = function(t) {
    if (t in e) return e[t].exports;
    if (t in i) {
      var o = i[t];
      delete i[t];
      var n = {
        id: t,
        exports: {}
      };
      return e[t] = n, o.call(n.exports, n, n.exports), n.exports;
    }
    var r = new Error("Cannot find module '" + t + "'");
    throw r.code = "MODULE_NOT_FOUND", r;
  }).register = function(t, e) {
    i[t] = e;
  }, t.parcelRequire5f74 = o), (0, o.register)("kmbQD", function(t, e) {
    var i, o, n, r;
    i = t.exports, o = "default", n = function() {
      return s;
    }, Object.defineProperty(i, o, {
      get: n,
      set: r,
      enumerable: !0,
      configurable: !0
    });
    class s {
      static doChange({id: t, quantity: e, properties: i = {}}, o = !1) {
        return fetch(`${Shopify.routes.root || "/"}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            id: t,
            quantity: e,
            properties: {
              ...i
            }
          })
        }).then(t => {
          if (!t.ok) throw new Error("Cart change failed");
          return t.ok && o && this.update(!0), t;
        }).catch(t => t);
      }
      static doUpdate(t, e, i = !1) {
        const o = Array.isArray(t) ? t.reduce((t, i) => ({
          ...t,
          [i]: e
        }), {}) : {
          id: e
        };
        return fetch(`${Shopify.routes.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            updates: o
          })
        }).then(t => {
          if (!t.ok) throw new Error("Cart update failed");
          return t.ok && i && this.update(!0), t;
        }).catch(t => t);
      }
      static doAdd({id: t, quantity: e, properties: i = {}}, o = !1, n = !0) {
        return fetch(`${Shopify.routes.root || "/"}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: [ {
              id: t,
              quantity: e,
              properties: {
                ...i
              }
            } ]
          })
        }).then(e => {
          if (!e.ok) throw new Error("Cart add failed");
          return e.ok && n ? (window.dispatchEvent(new CustomEvent("product:added", {
            detail: {
              variantId: t
            }
          })), e) : e.ok && o ? (this.update(!0), e) : void 0;
        }).catch(t => t);
      }
      static getCart() {
        return fetch(`${Shopify.routes.root || "/"}cart.js`, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        }).then(t => {
          if (!t.ok) throw new Error("Failed to fetch cart");
          return t;
        }).catch(t => t);
      }
      static cleanupTeleportedContent() {
        document.querySelectorAll("[data-teleport-origin]").forEach(t => {
          t.remove();
        });
      }
      static update(t = !1, e = "cart-drawer", i = null) {
        try {
          e = e.replace("cart-drawer", document.querySelector("cart-drawer").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        try {
          e = e.replace("cart-notification", document.querySelector("cart-notification").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        (e = e.split(",")).push("header"), e = [ ...new Set(e) ];
        const o = document.getElementById("Cart"), n = !!t || o && o.checked;
        return fetch(`${location.pathname}?sections=${e.join(",")}`, {
          method: "GET"
        }).then(t => t.json()).then(t => {
          this.cleanupTeleportedContent(), Object.entries(t).forEach(t => {
            const [e, o] = t, r = (new DOMParser).parseFromString(o, "text/html");
            if (e.includes("cart-notification")) {
              const t = document.querySelector("cart-notification"), e = r.querySelector("cart-notification");
              t && e && (t.innerHTML = e.innerHTML);
            }
            i ??= [ `[id^="shopify-section-"][id$="${e}"]` ], i.push("header [data-cart-count-desktop]", "header [data-cart-count-mobile]", "form [data-cart-count]", "[data-cart-link]"), 
            i.forEach(t => {
              document.querySelectorAll(t).forEach(e => {
                const i = r.querySelector(t);
                i && (e.innerHTML = n ? i.innerHTML.replace('id="Cart"', 'id="Cart" checked') : i.innerHTML);
              });
            });
          });
        });
      }
    }
  });
  var n = o("kmbQD");
  class r extends HTMLElement {
    constructor() {
      super(), this.mediaContainer = null, this.mediaItems = [], this.currentMediaIndex = 0, 
      this.cyclingInterval = null, this.cyclingSpeed = 800, this.isHovering = !1, this.favoriteElement = null, 
      this.isTouchDevice = this.detectTouchDevice(), this.touchStarted = !1, this.documentTouchHandler = null, 
      this.touchStartTime = 0, this.touchStartPos = {
        x: 0,
        y: 0
      }, this.isDragging = !1, this.tapThreshold = 150, this.dragThreshold = 10;
    }
    connectedCallback() {
      this.init(), this.setupVariantClickListeners(), this.setupTouchBehavior();
    }
    detectTouchDevice() {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
    init() {
      this.mediaContainer = this.querySelector("[data-media-container]"), this.mediaItems = this.querySelectorAll("[data-media-item]"), 
      this.variants = this.querySelectorAll("[data-variant]"), this.favoriteElement = this.querySelector(".product-card__favourite"), 
      this.mediaItems.length > 1 && this.setupMediaCycling();
    }
    setupMediaCycling() {
      this.addEventListener("mouseenter", this.startMediaCycling.bind(this)), this.addEventListener("mouseleave", this.stopMediaCycling.bind(this));
    }
    setupVariantClickListeners() {
      this.variants.forEach(t => {
        t.addEventListener("click", e => {
          e.preventDefault(), e.stopPropagation();
          const i = t.dataset.id;
          t.hasAttribute("data-out-of-stock") ? this.showOutOfStockModal(i) : i && !t.hasAttribute("data-loading") && this.addToCart(i, t);
        });
      });
    }
    setupTouchBehavior() {
      this.isTouchDevice && (this.addEventListener("touchstart", this.handleTouchStart.bind(this), {
        passive: !0
      }), this.addEventListener("touchend", this.handleTouchEnd.bind(this)), this.addEventListener("touchmove", this.handleTouchMove.bind(this), {
        passive: !0
      }), this.favoriteElement && (this.documentTouchHandler = this.handleDocumentTouch.bind(this)));
    }
    handleTouchStart(t) {
      this.touchStarted = !0, this.touchStartTime = Date.now(), this.touchStartPos = {
        x: t.touches[0].clientX,
        y: t.touches[0].clientY
      }, this.isDragging = !1, this.favoriteElement && (this.showFavoriteButton(), document.addEventListener("touchstart", this.documentTouchHandler, {
        passive: !0
      }));
    }
    handleTouchEnd(t) {
      this.touchStarted = !1;
      const e = Date.now() - this.touchStartTime, i = t.target;
      if (!(i.closest("[data-variant]") || i.closest(".product-card__favourite") || i.closest("quick-add-modal")) && !this.isDragging && e < this.tapThreshold) {
        const t = this.querySelector("a");
        t && (window.location.href = t.href);
      }
    }
    handleTouchMove(t) {
      if (!this.touchStarted) return;
      const e = t.touches[0].clientX, i = t.touches[0].clientY, o = Math.abs(e - this.touchStartPos.x), n = Math.abs(i - this.touchStartPos.y);
      (o > this.dragThreshold || n > this.dragThreshold) && (this.isDragging = !0), this.favoriteElement && this.showFavoriteButton();
    }
    handleDocumentTouch(t) {
      this.favoriteElement && (this.contains(t.target) || (this.hideFavoriteButton(), 
      document.removeEventListener("touchstart", this.documentTouchHandler)));
    }
    showFavoriteButton() {
      this.favoriteElement && (this.favoriteElement.style.opacity = "1", this.favoriteElement.style.pointerEvents = "auto");
    }
    hideFavoriteButton() {
      this.favoriteElement && (this.favoriteElement.style.opacity = "0", this.favoriteElement.style.pointerEvents = "none");
    }
    showOutOfStockModal(t) {
      const e = this.querySelector("out-of-stock-form");
      if (e) {
        document.dispatchEvent(new CustomEvent("product-card:show-out-of-stock-modal", {
          detail: {
            variantId: parseInt(t),
            productId: this.dataset.productId
          }
        }));
        const i = e.closest("teleport-details");
        if (i) {
          const t = i.querySelector("details");
          if (t) {
            const e = t.querySelector("summary");
            if (e) e.click(); else {
              const e = t.closest("details-disclosure");
              e && e.close instanceof Function && e.open();
            }
          } else console.error("Details element not found in teleport-details");
        } else console.error("Teleport-details parent not found for out-of-stock modal");
      } else console.error("Out-of-stock modal not found");
    }
    addToCart(t, e) {
      e.setAttribute("data-loading", "true");
      const i = e.innerHTML;
      e.innerHTML = window.strings.adding, n.default.doAdd({
        id: t,
        quantity: 1
      }, !0).then(t => {
        200 === t.status ? e.innerHTML = window.strings.added : e.innerHTML = window.strings.error;
      }).catch(() => {
        e.innerHTML = window.strings.error;
      }).finally(() => {
        setTimeout(() => {
          e.innerHTML = i, e.removeAttribute("data-loading");
        }, 1e3);
      });
    }
    startMediaCycling() {
      this.isHovering || this.mediaItems.length <= 1 || (this.isHovering = !0, this.currentMediaIndex = 0, 
      this.cyclingInterval = setInterval(() => {
        this.showNextMedia();
      }, this.cyclingSpeed));
    }
    stopMediaCycling() {
      this.isHovering = !1, this.cyclingInterval && (clearInterval(this.cyclingInterval), 
      this.cyclingInterval = null), this.resetToFirstMedia();
    }
    showNextMedia() {
      this.mediaItems[this.currentMediaIndex].classList.add("hidden"), this.currentMediaIndex = (this.currentMediaIndex + 1) % this.mediaItems.length, 
      this.mediaItems[this.currentMediaIndex].classList.remove("hidden");
    }
    resetToFirstMedia() {
      this.mediaItems.forEach(t => t.classList.add("hidden")), this.currentMediaIndex = 0, 
      this.mediaItems[0].classList.remove("hidden");
    }
    disconnectedCallback() {
      this.cyclingInterval && clearInterval(this.cyclingInterval), this.documentTouchHandler && document.removeEventListener("touchstart", this.documentTouchHandler);
    }
  }
  customElements.get("product-card") || customElements.define("product-card", r);
}();